import { render, staticRenderFns } from "./UiStatsChart.vue?vue&type=template&id=8f671248"
import script from "./UiStatsChart.vue?vue&type=script&lang=js"
export * from "./UiStatsChart.vue?vue&type=script&lang=js"
import style0 from "./UiStatsChart.vue?vue&type=style&index=0&id=8f671248&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports